const isAdminOwnerId = (ownerId) => ownerId == null ? void 0 : ownerId.endsWith("admin");
export const adminAssignee = (ownerId) => isAdminOwnerId(ownerId) ? { id: ownerId, label: "Administrator", type: "user" } : void 0;
